import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Layout } from "../components/tag/Layout";
import { api } from "../lib/api";

const fields = [
  { key: "name", label: "Full name" },
  { key: "website", label: "Website URL" },
  { key: "industry", label: "Industry or niche" },
  { key: "offer", label: "Primary offer or service" },
  { key: "frustration", label: "Current biggest frustration with online visibility", multiline: true },
  { key: "success_vision", label: "What success looks like in 90 days", multiline: true },
  { key: "notes", label: "Anything else we should know before your audit", multiline: true, optional: true },
];

export default function AuditIntake() {
  const [params] = useSearchParams();
  const [form, setForm] = useState({
    email: params.get("email") || "",
    name: "",
    website: "",
    industry: "",
    offer: "",
    frustration: "",
    success_vision: "",
    notes: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      toast.error("Please enter a valid email.");
      return;
    }
    for (const f of fields) {
      if (!f.optional && !form[f.key].trim()) {
        toast.error(`Please fill: ${f.label}`);
        return;
      }
    }
    setSubmitting(true);
    try {
      await api.post("/audit/intake", form);
      setDone(true);
    } catch {
      toast.error("Could not submit intake. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout title="Audit Intake | The Authority Gap" path="/audit/intake">
      <section style={{ background: "#090909", padding: "60px 20px 80px" }}>
        <div className="tag-card" data-testid="audit-intake-card" style={{ maxWidth: 560, margin: "0 auto", padding: 32 }}>
          {!done ? (
            <>
              <h2 className="tag-h2" style={{ marginBottom: 8 }}>Tell us about yourself</h2>
              <p style={{ color: "#aaa", fontSize: 13, marginBottom: 24 }}>This helps us personalize your audit.</p>
              <form onSubmit={submit}>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: "block", color: "#888", fontSize: 11, marginBottom: 6, fontWeight: 600 }}>Email</label>
                  <input data-testid="intake-email" type="email" required value={form.email} onChange={(e) => set("email", e.target.value)} className="tag-input" />
                </div>
                {fields.map((f) => (
                  <div key={f.key} style={{ marginBottom: 14 }}>
                    <label style={{ display: "block", color: "#888", fontSize: 11, marginBottom: 6, fontWeight: 600 }}>{f.label}{f.optional ? " (optional)" : ""}</label>
                    {f.multiline ? (
                      <textarea
                        data-testid={`intake-${f.key}`}
                        rows={3}
                        value={form[f.key]}
                        onChange={(e) => set(f.key, e.target.value)}
                        className="tag-input"
                        style={{ resize: "vertical", minHeight: 80, fontFamily: "var(--font-body)" }}
                      />
                    ) : (
                      <input
                        data-testid={`intake-${f.key}`}
                        value={form[f.key]}
                        onChange={(e) => set(f.key, e.target.value)}
                        className="tag-input"
                      />
                    )}
                  </div>
                ))}
                <button data-testid="intake-submit" type="submit" className="btn-primary" style={{ width: "100%" }} disabled={submitting}>
                  {submitting ? "Submitting…" : "Submit My Intake"}
                </button>
              </form>
            </>
          ) : (
            <div data-testid="intake-success" style={{ textAlign: "center", padding: "32px 0" }}>
              <div style={{ color: "#FF6575", fontSize: 56, marginBottom: 12 }}>✓</div>
              <h2 className="tag-h2" style={{ marginBottom: 12 }}>Submitted.</h2>
              <p style={{ color: "#bbb", fontSize: 13 }}>We'll be in touch within 24 hours.</p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
